// TODO: move to chat-channel module folder

import { useCallback } from 'react';
import { useFileUploadContext } from 'src/provider/FileUploadContext';
import { AssetsRequests } from 'src/requests/assets';

export const useConversationMediaUpload = () => {
  const { control } = useFileUploadContext();

  const uploadMediaFile = useCallback(
    async (file: File) => {
      let _file = file;
      const [fileUpload] = control.addFiles([_file]);

      const response = await AssetsRequests.uploadPrivateFile(
        _file,
        (progress, speed) => {
          control.updateFile({
            ...fileUpload,
            file: _file,
            progress,
            speed,
          });
        },
      );

      control.removeFiles([fileUpload]);

      return response;
    },
    [control],
  );

  return { uploadMediaFile };
};
